import Action from '../_Action';

/**
 * @visibleName
 * @component
 */
export default class CloseCollapseById extends Action {
  /** The action namespace */
  static namespace = 'Core/Collapse';

  /** The base action type */
  static type = 'Core/Collapse/CloseCollapseById';

  /** The action identifier */
  static identifier = 'collapseId';

  /** The collapse id */
  collapseId: number;

  constructor(
    /** The collapse id */
    collapseId: number,
  ) {
    super();
    this.type = `${(this.constructor as typeof CloseCollapseById).type}/${collapseId}`;
    this.collapseId = collapseId;
  }
}
